<app-header></app-header>

<div class="main-container">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="w-full-col p-30">
          <div class="pro-container">
            <div class="profile-info">
              <div class="profile-summery">
                <div class="profile-img">
                  <img *ngIf="imgUrl" src="{{imgUrl}}" alt="">
                  <img *ngIf="!imgUrl" src="../../../assets/images/loading/loading.gif" alt="">
                </div>
                <h4>{{userName}}</h4>
                <span class="pro-contact" *ngIf="showDetails">{{this.displayMobile}}</span>
                <span class="pro-contact" *ngIf="!showDetails">+XX XXX XXX XXX</span>
                <span class="pro-country" *ngIf="showDetails">{{displayCountry}}</span>
                <span class="pro-country" *ngIf="!showDetails">XXXXXX</span>

              </div>
              <div class="pro-link">
                <a [routerLink]="['/my-order/'+tenantValue]">
                  <i aria-hidden="true" class="fa fa-shopping-bag"></i> My Orders <i class="fa fa-long-arrow-right"
                                                                                     aria-hidden="true"></i>
                </a>
                <a [routerLink]="['/cart/'+tenantValue]">
                  <i aria-hidden="true" class="fa fa-shopping-cart"></i> My Shopping Cart <i
                  class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </a>

                <a [routerLink]="['/view-bids/'+tenantValue]">
                  <i class="fa fa-bitbucket" aria-hidden="true"></i>View Bids<i class="fa fa-long-arrow-right"
                                                                                aria-hidden="true"></i>
                </a>

                <a [routerLink]="['/award-bid/'+tenantValue]">
                  <i class="fa fa-trophy" aria-hidden="true"></i>View Award Bids<i class="fa fa-long-arrow-right"
                                                                                   aria-hidden="true"></i></a>
                <a *ngIf="FORWARD_ORDER_ENABLE" [routerLink]="['/add-product/'+tenantValue]">
                  <i class="fa fa-plus" aria-hidden="true"></i>Place Forward Order<i class="fa fa-long-arrow-right"
                                                                                     aria-hidden="true"></i>
                </a>
                <a *ngIf="FORWARD_ORDER_ENABLE" [routerLink]="['/product-future/'+tenantValue]">
                  <i class="fa fa-eye" aria-hidden="true"></i>Forward Order Bids <i class="fa fa-long-arrow-right"
                                                                                    aria-hidden="true"></i>
                </a>

              </div>
            </div>

            <div class="pro-right-col my-order" style="padding-top: 0;">

              <div *ngIf="!allOrders">
                <div class="sk-cube-grid">
                  <div class="sk-cube sk-cube1"></div>
                  <div class="sk-cube sk-cube2"></div>
                  <div class="sk-cube sk-cube3"></div>
                  <div class="sk-cube sk-cube4"></div>
                  <div class="sk-cube sk-cube5"></div>
                  <div class="sk-cube sk-cube6"></div>
                  <div class="sk-cube sk-cube7"></div>
                  <div class="sk-cube sk-cube8"></div>
                  <div class="sk-cube sk-cube9"></div>
                </div>
              </div>

              <div *ngIf="!foundResult" style="border: 1px solid;height: 100px;width: 100%;">
                <label style="
                   width: 100%;
                   margin-top: 5vh;
                   margin-left: 1vw;">Oops! That's not available in our catalogue. Please try again with different
                  search criteria.</label>
              </div>

              <div *ngIf="foundResult" class="row" style="height: 580px; overflow-y: scroll;">

                <div class="col-lg-4 col-md-4" *ngFor="let item of allOrders">
                  <div class="ps-item" style="padding: 10px !important; margin-bottom: 20px;">
                    <div class="ps-inner-wrapper">
                      <img class="imageTag"
                           [src]="this.mainUrl.MAIN_URL_FILE + item.productImages[0].image+'/?X-TenantID=' + this.tenantValue"
                           alt=""/>
                      <div class="ps-item-inner">
                        <h5>{{item.name}}</h5>
                        <h4>{{item.currency}}<span>&nbsp;</span>{{item.unitPrice| number:'2.2-2'}}</h4>
                      </div>
                      <dl class="ps-item-date">
                        <dt>Awarded on</dt>
                        <dd>{{convertDate(item.created)}}</dd>
                      </dl>
                      <button [routerLink]="['/checkout/'+tenantValue]" [queryParams]="{sku:item.productSku}"
                              style="margin-top: 1vh; width: 100%;" type="button"
                              class="btn btn-secondary reviewButton"> Checkout
                      </button>
                    </div>
                  </div>
                </div>


              </div>


            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
